import classNames from 'classnames'
import React, { Fragment } from 'react'
import { observer } from 'mobx-react-lite'
import { Box, Error, InputCheckbox, Label, Typography } from 'shared/ui'
import { TextField } from 'shared/ui/TextField'
import { useRcsCreateContext } from 'pages/settings/pages/rcs/context/rcsCreateContext'

import styles from './styles.module.scss'

export const BrandTermsSection: React.FC = observer(() => {
  const {
    profileStore: {
      privacyPolicyUrl,
      setPrivacyPolicyUrl,
      privacyPolicyError,
      termsAndConditionsUrl,
      setTermsAndConditionsUrl,
      termsAndConditionsError,
      termsAndConditionsAgreed,
      setTermsAndConditionsAgreed,
      termsAndConditionsAgreedError,
    },
  } = useRcsCreateContext()

  return (
    <Fragment>
      <Box display={'grid'} gap={'4px'} mb={'20px'} mt={'35px'}>
        <Label
          label={{
            text: 'Privacy policy URL',
            textColor: 'var(--content-primary-primary)',
            horizontal: true,
          }}
        />
        <TextField
          size='medium'
          variant='stroke'
          error={privacyPolicyError}
          InputProps={{
            placeholder: 'https://',
          }}
          className={classNames({
            [styles.fieldError]: !!privacyPolicyError,
          })}
          value={privacyPolicyUrl}
          onChange={setPrivacyPolicyUrl}
        />
        <Error type='text' error={privacyPolicyError} />
      </Box>
      <Box display={'grid'} gap={'4px'} mb={'40px'}>
        <Label
          label={{
            textColor: 'var(--content-primary-primary)',
            text: 'Terms and conditions URL',
            horizontal: true,
          }}
        />
        <TextField
          size='medium'
          variant='stroke'
          error={termsAndConditionsError}
          InputProps={{
            placeholder: 'https://',
          }}
          className={classNames({
            [styles.fieldError]: !!termsAndConditionsError,
          })}
          value={termsAndConditionsUrl}
          onChange={setTermsAndConditionsUrl}
        />
        <Error type='text' error={termsAndConditionsError} />
      </Box>
      <div>
        <InputCheckbox
          checked={termsAndConditionsAgreed}
          className={styles.termsAndConditionsCheckbox}
          color='var(--content-primary-secondary)'
          customLabel={
            <Typography
              ariaLabel='termsAndConditionsCheckbox'
              variant='text-input-field-r'
              color='var(--content-primary-secondary)'
            >
              I agree to be contacted by support to complete my compliance
              <br />
              setup and understand that RCS is currently in beta. Pricing and
              <br />
              specific requirements will be reviewed together during the setup process.
            </Typography>
          }
          onChecked={() => setTermsAndConditionsAgreed(!termsAndConditionsAgreed)}
        />
        <Error type='text' error={termsAndConditionsAgreedError} />
      </div>
    </Fragment>
  )
})
